/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { HenviserDto as OkEgisServiceModelsDtoHenviserDto } from '../models/OK/Egis/Service/Models/DTO/henviser-dto';
import { GetHenviserRequest as OkEgisServiceModelsRequestGetHenviserRequest } from '../models/OK/Egis/Service/Models/Request/get-henviser-request';
import { HenviserRequest as OkEgisServiceModelsRequestHenviserRequest } from '../models/OK/Egis/Service/Models/Request/henviser-request';

@Injectable({
  providedIn: 'root',
})
export class HenviserService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getHenvisere
   */
  static readonly GetHenviserePath = '/api/v1/Henviser';

  /**
   * Returns a list of Partners.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHenvisere()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getHenvisere$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestGetHenviserRequest
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoHenviserDto>>> {

    const rb = new RequestBuilder(this.rootUrl, HenviserService.GetHenviserePath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoHenviserDto>>;
      })
    );
  }

  /**
   * Returns a list of Partners.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getHenvisere$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getHenvisere(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestGetHenviserRequest
  }): Observable<Array<OkEgisServiceModelsDtoHenviserDto>> {

    return this.getHenvisere$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoHenviserDto>>) => r.body as Array<OkEgisServiceModelsDtoHenviserDto>)
    );
  }

  /**
   * Path part for operation addHenviser
   */
  static readonly AddHenviserPath = '/api/v1/Henviser/AddHenviser';

  /**
   * Adds a henviser.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addHenviser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addHenviser$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestHenviserRequest
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoHenviserDto>> {

    const rb = new RequestBuilder(this.rootUrl, HenviserService.AddHenviserPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoHenviserDto>;
      })
    );
  }

  /**
   * Adds a henviser.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `addHenviser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addHenviser(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestHenviserRequest
  }): Observable<OkEgisServiceModelsDtoHenviserDto> {

    return this.addHenviser$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoHenviserDto>) => r.body as OkEgisServiceModelsDtoHenviserDto)
    );
  }

  /**
   * Path part for operation updateHenviser
   */
  static readonly UpdateHenviserPath = '/api/v1/Henviser/UpdateHenviser';

  /**
   * Updates a henviser.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateHenviser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateHenviser$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestHenviserRequest
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoHenviserDto>> {

    const rb = new RequestBuilder(this.rootUrl, HenviserService.UpdateHenviserPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoHenviserDto>;
      })
    );
  }

  /**
   * Updates a henviser.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateHenviser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateHenviser(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestHenviserRequest
  }): Observable<OkEgisServiceModelsDtoHenviserDto> {

    return this.updateHenviser$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoHenviserDto>) => r.body as OkEgisServiceModelsDtoHenviserDto)
    );
  }

  /**
   * Path part for operation removeHenviser
   */
  static readonly RemoveHenviserPath = '/api/v1/Henviser/RemoveHenviser';

  /**
   * Deletes a henviser.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeHenviser()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeHenviser$Response(params: {
    id?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, HenviserService.RemoveHenviserPath, 'delete');
    if (params) {
      rb.query('id', params.id, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Deletes a henviser.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `removeHenviser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeHenviser(params: {
    id?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<void> {

    return this.removeHenviser$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
